import { createClient } from '@supabase/supabase-js';
const supabaseUrl = process.env.SUPABASE_URL || '';
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY || '';
let _supabase = null;
function getSupabase() {
    if (!_supabase) {
        if (!supabaseUrl || !supabaseAnonKey) {
            throw new Error('Supabase is not configured. Set SUPABASE_URL and SUPABASE_ANON_KEY environment variables.');
        }
        _supabase = createClient(supabaseUrl, supabaseAnonKey);
    }
    return _supabase;
}
export async function uploadProductImage(file) {
    const supabase = getSupabase();
    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}-${Date.now()}.${fileExt}`;
    const filePath = `products/${fileName}`;
    const { error } = await supabase.storage
        .from('product-images')
        .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
    });
    if (error) {
        console.error('Supabase upload error:', error);
        throw new Error(error.message || 'Failed to upload image');
    }
    const { data } = supabase.storage
        .from('product-images')
        .getPublicUrl(filePath);
    return data.publicUrl;
}
